// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__ZYpRC","fade-slice":"styles_fade-slice__3dz8Z"};